/** Mutation keys other code needs to recognise a request by, kept apart from
 *  `declarationsApi.ts` so a test that replaces that module still sees them. */

/** `POST /declarations/{id}/review`, the final review `useReviewNow` asks for.
 *  The approve footer counts this declaration's mutations as "saving"; a review
 *  request is no save, and is told apart by this key. */
export const REVIEW_NOW_MUTATION_KEY = [
  "mc",
  "declarations",
  "review-now",
] as const

export function isReviewNowMutation(
  mutationKey: readonly unknown[] | undefined,
): boolean {
  return (
    mutationKey !== undefined &&
    mutationKey.length === REVIEW_NOW_MUTATION_KEY.length &&
    REVIEW_NOW_MUTATION_KEY.every((part, i) => mutationKey[i] === part)
  )
}
